import { ISavePartnerComplianceProps } from 'onboarding/classes/models/partnerCompliance'
import { callJSend } from 'shared/lib/http/callJSend'

import { PARTNER_STATUS_ENDPOINT } from './partnerStatusApi'

const FALLBACK_MESSAGE = 'Failed to save the compliance'

class PartnerComplianceApi {
  /**
   * Authenticated by the mailed link rather than the session: the partner the decision applies to
   * lives in that token's claims, so it is the credential the endpoint reads.
   */
  public async save(props: ISavePartnerComplianceProps, token: string) {
    const response = await callJSend<{ partnerStatus?: string; message?: string }>({
      method: 'post',
      url: `${PARTNER_STATUS_ENDPOINT}/compliance-decision`,
      payload: props,
      linkToken: token,
    })

    if (response.status !== 'success') {
      throw new Error(response.data?.message || response.message || FALLBACK_MESSAGE)
    }

    return true
  }
}

export const partnerComplianceApi = new PartnerComplianceApi()
